<template>
  <div
    id="election-news-updates"
    class="voter-info__page-section election-news-updates__wrapper"
  >
    <span class="election-news-updates__title">
      <icon
        icon-name="info"
        view-box="0 0 24 24"
        class="election-news-updates__title--icon"
      />
      <span class="election-news-updates__title--text">{{ stateName }} Election Changes</span>
    </span>
    <p
      class="election-news-updates__content"
      v-html="newsUpdates"/>
  </div>
</template>

<script>
import Icon from "StyleguideComponents/Icon.vue";

export default {
  name: "ElectionNewsUpdates",
  components: {
    Icon
  },
  props: {
    stateName: {
      type: String,
      required: true
    },
    newsUpdates: {
      type: String,
      required: true
    }
  }
};
</script>
